import styled from 'styled-components';
import { Flex } from 'antd';
import { SbSelect } from 'uiCore';
import { JobsTableWrapperStyled } from 'Pages/JobsLibraryV2/JobsLibraryV2.styles';
import { PickerLabelStyled } from 'Components/JdOwnership/PersonPickerModal.styles';
import {
  ConflictProjectItemStyled, ConflictProjectListStyled,
} from 'Components/EmployeeFunctionAccess/EmployeeFunctionAccess.styles';

// The wireframe's selection bar (#own-bar): "N selected" / the hint, then Transfer and Clear selection. Nothing in the
// app has this bar; everything else on the page reuses existing components and styles.
export const SelectionBarStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  border: 1px solid #b3cdfb;
  border-radius: 6px;
  background: rgba(1, 85, 231, 0.08);
  color: #565e70;

  > :first-child {
    margin-right: auto;
  }
`;

// The parts around the table keep their height, so the table area (TableWrapperStyled, as on the Jobs Library page)
// takes the rest of the page and scrolls.
export const TabsBarStyled = styled.div`
  flex-shrink: 0;
  padding: 0 24px;

  .ant-tabs-nav {
    margin-bottom: 12px;
  }
`;

export const ControlsStyled = styled.div`
  flex-shrink: 0;
  padding: 0 24px;
`;

// The Jobs Library table wrapper, with rows at least two lines tall (a wrapped job title fits without the row growing,
// and short rows don't look cramped) and room between the job title and the owner.
export const TransferTableStyled = styled(JobsTableWrapperStyled)`
  .ant-table-tbody > tr > td {
    height: 60px;
  }

  .ant-table-thead > tr > th.ownership-col-title,
  .ant-table-tbody > tr > td.ownership-col-title {
    padding-right: 32px;
  }
`;

// ── The transfer popups (TransferParts, TransferOwnershipModal, TransferEverythingModal) ─────────────────────────────
// The existing pieces they reuse (the people pickers' label and the conflict list), with the few spacing changes the
// popups need.

// A field label on the same line as its controls (no gap under it)
export const InlinePickerLabelStyled = styled(PickerLabelStyled)`
  margin-bottom: 0;
`;

// A full-width dropdown
export const FullWidthSelectStyled = styled(SbSelect)`
  width: 100%;
`;

// The JDs being moved: the conflict list without its gap underneath
export const TransferItemsListStyled = styled(ConflictProjectListStyled)`
  margin-bottom: 0;
`;

// The JDs a person owns (Transfer everything): a compact list under its summary line, scrolling past six or so
export const OwnedItemsListStyled = styled(ConflictProjectListStyled)`
  margin: 6px 0 0;
  max-height: 168px;
  overflow-y: auto;
`;

export const CompactItemStyled = styled(ConflictProjectItemStyled)`
  padding: 4px 10px;
`;

// One line per JD: its title at the left, its Role ID at the right
export const ItemLineStyled = styled(Flex)`
  width: 100%;
`;
